export const birthdays = {
  title: "Anniversaires à Gándara",
  subtitle: "Célébrez l'anniversaire de votre enfant dans notre espace naturel avec des activités uniques et amusantes",
  courseYear: "Année scolaire 2025-2026",
  
  gallery: {
    title: "Moments d'anniversaire à Gándara",
    caption: "Un espace spécial pour célébrer entouré de nature",
    images: [
      {
        src: "/lovable-uploads/patio-recetas-flores.jpg",
        alt: "Enfants profitant des espaces naturels de Gándara"
      },
      {
        src: "/lovable-uploads/corro-plaza-piedra.png",
        alt: "Activités de plein air pour anniversaires"
      },
      {
        src: "/lovable-uploads/patio-rampa-pales.png",
        alt: "Espaces préparés pour les célébrations"
      }
    ]
  },
  
  generalInfo: {
    title: "Informations Générales",
    availabilityLabel: "Disponibilité",
    availability: "Vendredis après-midi, Samedis et Dimanches",
    durationLabel: "Durée",
    duration: "3-4 heures",
    description: "Nous offrons un espace unique pour célébrer les anniversaires d'enfants dans un environnement naturel et respectueux. Nos célébrations sont conçues pour que les enfants profitent d'une expérience mémorable entourés de nature, avec des activités éducatives et ludiques qui encouragent la créativité et le jeu libre."
  },
  
  plans: {
    title: "Forfaits Disponibles",
    priceNote: "jusqu'à 15 enfants",
    aTuAire: {
      name: "À Votre Façon",
      description: "Espace privé pour votre célébration",
      features: [
        "Utilisation de nos installations",
        "Accès aux zones naturelles",
        "Sans accompagnement éducatif"
      ],
      priceSmall: "120€",
      priceLarge: "180€"
    },
    acompanada: {
      name: "Accompagné",
      description: "Avec animateur/trice professionnel(le)",
      features: [
        "Tout inclus dans 'À Votre Façon'",
        "Animateur/trice éducatif/ve",
        "1 atelier dirigé au choix"
      ],
      priceSmall: "250€",
      priceLarge: "400€"
    },
    experienciaCompleta: {
      name: "Expérience Complète",
      description: "La célébration la plus spéciale",
      badge: "Recommandé",
      features: [
        "Tout inclus dans 'Accompagné'",
        "2 ateliers dirigés au choix",
        "Décoration thématique",
        "Zone de goûter préparée"
      ],
      priceSmall: "400€",
      priceLarge: "500€"
    }
  },
  
  pricingTable: {
    title: "Tableau des Prix",
    headers: {
      plan: "Forfait",
      small: "Jusqu'à 15 enfants",
      large: "16-30 enfants"
    }
  },
  
  workshops: {
    title: "Ateliers Disponibles",
    items: [
      "Coins de jeu",
      "Atelier d'art",
      "Maquillage",
      "Bulles géantes",
      "Cuisine créative",
      "Sensoriel",
      "Bracelets",
      "DIY (Faites-le vous-même)"
    ]
  },
  
  extras: {
    title: "Extras Disponibles",
    items: [
      { name: "Mini-Discothèque", price: "50€" },
      { name: "Goûter pour adultes", price: "6€/personne" },
      { name: "Nettoyage supplémentaire", price: "30€" },
      { name: "Gâteau d'anniversaire", price: "40€" },
      { name: "Atelier supplémentaire", price: "50€" }
    ]
  },
  
  booking: {
    title: "Processus de Réservation",
    deposit: "Acompte",
    depositDescription: "Un acompte de 50€ est requis, qui sera déduit du prix final de la célébration.",
    cancellation: "Politique d'Annulation",
    cancellationDescription: "Les annulations doivent être faites au moins 1 semaine à l'avance pour un remboursement complet de l'acompte."
  },
  
  form: {
    title: "Demande de Réservation",
    contactSection: "Coordonnées",
    birthdaySection: "Détails de l'Anniversaire",
    preferencesSection: "Préférences",
    extrasSection: "Extras (Optionnel)",
    
    fields: {
      parentName: "Nom du parent",
      email: "Email",
      phone: "Téléphone",
      childName: "Nom de l'enfant",
      childAge: "Âge de l'enfant",
      numberOfChildren: "Nombre d'enfants invités",
      preferredDate: "Date préférée",
      alternativeDate: "Date alternative (optionnel)",
      selectedPlan: "Forfait sélectionné",
      preferredWorkshops: "Ateliers préférés (maximum 2)",
      adultSnacksCount: "Nombre d'adultes",
      comments: "Commentaires supplémentaires",
      acceptTerms: "J'accepte les termes et conditions"
    },
    
    placeholders: {
      parentName: "Marie Dupont",
      email: "marie@example.com",
      phone: "+34 600 123 456",
      childName: "Nom de l'enfant qui fête son anniversaire",
      comments: "Préférences, besoins particuliers... Si un enfant a des allergies, indiquez-nous seulement lesquelles et combien d'enfants, sans les nommer."
    },
    
    submit: "Envoyer la demande de réservation",
    submitting: "Envoi en cours...",
    success: "Demande envoyée avec succès ! Nous vous contactons bientôt.",
    error: "Erreur lors de l'envoi de la demande. Veuillez réessayer."
  },
  
  contact: {
    title: "Des questions ?",
    description: "Contactez-nous pour plus d'informations sur la disponibilité, les prix et les options de personnalisation.",
    emailButton: "Contacter par email"
  }
};
